import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { OrchidModule } from '@upmc-healthplan-npm/ods-ng';
import '@upmc-healthplan-npm/ods-wc';

import { ErrorContainerComponent } from './components/error-container/error-container.component';
import { NetworkNavigationComponent } from './components/network-navigation/network-navigation.component';
import { FilterNavigationComponent } from './components/filter-navigation/filter-navigation.component';
import { NotificationContainerComponent } from './components/notification-container/notification-container.component';
import { MapViewComponent } from './components/map-view/map-view.component';
import { SelectPcpComponent } from './components/select-pcp/select-pcp.component';
import { SelectLocationComponent } from './components/select-location/select-location.component';
import { LoadingScreenComponent } from './components/loading-screen/loading-screen.component';
import { ProvdirModalComponent } from './components/provdir-modal/provdir-modal.component';
import { DropdownContainerComponent } from './components/filter-navigation/dropdown-container/dropdown-container.component';
import { TooltipComponent } from './components/generic/tooltip/tooltip.component';
import { SheetsComponent } from './components/sheets/sheets.component';

import { PhonePipe } from './pipes/phone.pipe';
import { AddressPipe } from './pipes/address.pipe';
import { DaysPipe } from './pipes/days.pipe';
import { HourPipe } from './pipes/hour.pipe';

import { SearchObjectService } from './services/search-object.service';
import { SearchResultObjectService } from './services/search-result-object.service';
//import { GoogleAnalyticsService } from './services/google-analytics.service';
import { NameInputDirective } from './directives/nameinput.directive';
import { StopPropagationDirective } from './directives/stoppropagation.directive';
import { KeyPressDirective } from './directives/keypresstoclick.directive';

import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatRadioModule } from '@angular/material/radio';
import { SelectedFiltersComponent } from './components/filter-navigation/selected-filters/selected-filters.component';
import { BannerCardComponent } from './components/banner-card/banner-card.component';
import { HighlightMatchPipe } from './pipes/highlight-match.pipe';
import { PhoneMaskDirective } from './directives/phonemask.directive';
import { FeatureFlagDirective } from './directives/feature-flag.directive';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        MatDialogModule,
        MatButtonModule,
        MatRadioModule,
        MatIconModule,
        BrowserAnimationsModule,
        OrchidModule
    ],
    declarations: [
        ErrorContainerComponent,
        NetworkNavigationComponent,
        FilterNavigationComponent,
        NotificationContainerComponent,
        MapViewComponent,
        SelectPcpComponent,
        SelectLocationComponent,
        LoadingScreenComponent,
        ProvdirModalComponent,
        DropdownContainerComponent,
        TooltipComponent,
        SheetsComponent,
        PhonePipe,
        AddressPipe,
        DaysPipe,
        HourPipe,
        HighlightMatchPipe,
        NameInputDirective,
        PhoneMaskDirective,
        StopPropagationDirective,
        KeyPressDirective,
        SelectedFiltersComponent,
        BannerCardComponent,
        FeatureFlagDirective
    ],
    exports: [
        MatDialogModule,
        ErrorContainerComponent,
        NetworkNavigationComponent,
        FilterNavigationComponent,
        NotificationContainerComponent,
        MapViewComponent,
        SelectPcpComponent,
        SelectLocationComponent,
        LoadingScreenComponent,
        ProvdirModalComponent,
        DropdownContainerComponent,
        TooltipComponent,
        SheetsComponent,
        BannerCardComponent,
        PhonePipe,
        AddressPipe,
        DaysPipe,
        HourPipe,
        HighlightMatchPipe,
        NameInputDirective,
        PhoneMaskDirective,
        StopPropagationDirective,
        KeyPressDirective,
        FeatureFlagDirective
    ],
    providers: [
        SearchObjectService,
        SearchResultObjectService
        //GoogleAnalyticsService
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})

export class SharedComponentsModule {
}
